<template>
  <div>
    <v-chip
      class="btn-explain"
      @click="dialogExplainStatus = true"
      outlined
    >
      <v-icon left small> mdi-help-circle-outline </v-icon>
      <span class="btn-explain-txt"> {{ $t('customer.explanation_status') }} </span>
    </v-chip>
    <v-dialog v-model="dialogExplainStatus" width="670" scrollable persistent>
      <v-card >
        <v-card-title class="d-flex justify-space-between align-center primary white--text">
          <div>
            <v-icon color="white" class="">mdi-help-circle-outline</v-icon>
            <span class="status-explain-title"> {{ $t('customer.explanation_status') }} </span>
          </div>
          <v-btn color="white" icon @click="dialogExplainStatus = false">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-0 py-0">
          <v-simple-table class="data-table-explain-status">
            <template v-slot:default>
              <tbody>
                <template v-if="viewType == 'table'">
                  <tr>
                    <td class="td-status">
                      <v-chip class="chip-status darkgray">
                        <v-icon left x-small > mdi-circle </v-icon>
                        {{ $t('area.empty_stall') }}
                      </v-chip>
                    </td>
                    <td>{{ $t('area.empty_stall_not_renter') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-chip class="chip-status success">
                        <v-icon left x-small > mdi-circle </v-icon>
                        {{ $t('invoice.no_pending_invoice') }}
                      </v-chip>
                    </td>
                    <td>{{ $t('area.monthly_renter_market_that_not_debt') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-chip class="chip-status error">
                        <v-icon left x-small> mdi-circle </v-icon>
                        {{ $t('payment.pending') }}
                      </v-chip>
                    </td>
                    <td>{{ $t('area.monthly_renter_market_that_have_debt') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-chip class="chip-status warning">
                        <v-icon left x-small> mdi-circle </v-icon>
                        {{ $t('suspend.suspend_sale') }}
                      </v-chip>
                    </td>
                    <td>{{ $t('suspend.renter_monthly_market_that_suspend') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <v-chip class="chip-status info">
                        <v-icon left x-small> mdi-circle </v-icon>
                        {{ $t('daily') }}
                      </v-chip>
                    </td>
                    <td>{{ $t('area.daily_renter_market') }}</td>
                  </tr>
                </template>

                <template v-if="viewType == 'plan'">
                  <tr>
                    <td class="td-status">
                      <div class="rect-icon gray"></div>
                    </td>
                    <td>{{ $t('area.empty_stall_not_renter') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <div class="rect-icon green"></div>
                    </td>
                    <td>{{ $t('area.monthly_renter_market_that_not_debt') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <div class="rect-icon red"></div>
                    </td>
                    <td>{{ $t('area.monthly_renter_market_that_have_debt') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <div class="rect-icon yellow"></div>
                    </td>
                    <td>{{ $t('suspend.renter_monthly_market_that_suspend') }}</td>
                  </tr>
                  <tr>
                    <td>
                      <div class="rect-icon blue"></div>
                    </td>
                    <td>{{ $t('area.daily_renter_market') }}</td>
                  </tr>
                </template>
                <tr>
                  <td>
                    <img class="status-icon" :src="require(`../assets/images/booking-stall-icon.svg`)" />
                  </td>
                  <td>{{ $t('booking.have_booking_stall') }}</td>
                </tr>
                <tr>
                  <td>
                    <img class="status-icon" :src="require(`../assets/images/areaInterest-icon.svg`)" />
                  </td>
                  <td>{{ $t('area.have_customer_interest_stall') }}</td>
                </tr>
                <tr>
                  <td>
                    <img class="status-icon" :src="require(`../assets/images/money-approve.svg`)" />
                  </td>
                  <td v-if="viewType == 'table'">
                    {{ $t('bill.renter_payment_in_stall') }}
                  </td>
                  <td v-if="viewType == 'plan'">
                    {{ $t('payment.payment_notification') }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <img class="status-icon" :src="require(`../assets/images/overdue.svg`)" />
                  </td>
                  <td>{{ $t('bill.overdue_bill') }}</td>
                </tr>
                <tr>
                  <td>
                    <img class="status-icon" :src="require(`../assets/images/contract-expire-1.svg`)" />
                  </td>
                  <td>{{ $t('contract.contract_will_expired') }}</td>
                </tr>
                <tr>
                  <td>
                    <img class="status-icon" :src="require(`../assets/images/contract-expire-2.svg`)" />
                  </td>
                  <td>{{ $t('contract.contract_expired') }}</td>
                </tr>
                <tr>
                  <td>
                    <img class="status-icon" :src="require(`../assets/images/meterprepaid.svg`)" />
                  </td>
                  <td>{{ $t('meter.meter_is_less_than_fifteen_unit') }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>

    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogExplainStatus: false,
    };
  },
  props: {
    viewType: {
      type: String,
      default: "table",
    },
  },
  methods: {
    openDialogExplainStatus() {
      this.dialogExplainStatus = true;
    },
  },
};
</script>
<style lang="scss" scoped>
  .btn-explain.v-chip.v-chip--outlined.v-chip.v-chip::v-deep {
    color: #609146;
    border-color: #609146;
    background-color: #ffffff !important;
  }
  .btn-explain-txt {
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
  }
  .status-explain-title {
    font-size: 20px;
    font-weight: 700;
    line-height: 30.24px;
  }
  .td-status {
    min-width: 130px !important;
    width: 130px;
  }
  .status-icon {
    width: 45px;
    margin: 8px 0 8px 0;
  }
  .rect-icon {
    width: 45px;
    height: 45px;
    margin: 8px 0 8px 0;
  }
  .gray {
    background: #C9C9C9 !important;
  }
  .green {
    background: #57B99D !important;
  }
  .red {
    background: #DF606F !important;
  }
  .yellow {
    background: #EDBB6B !important;
  }
  .blue {
    background: #0691E1 !important;
  }
</style>
